import styles from "./profile.module.css";
function UserProfile({
  label,
  num,
  postalCode,
  postal,
  email,
  emailLabel,
  familyName,
  codeMeli,
  address,
  id,
  lName,
  fName,
}) {
  return (
    <>
      <div
        className={`d-flex flex-column align-items-center justify-content-center text-center ${styles.userProfile}`}
      >
        <div
          className={`w-100 oo d-flex flex-column align-items-center justify-content-evenly text-center ${styles.userDetail}`}
        >
          <label>{label}</label>
          <p>{id === 1 ? num : fName + " " + lName}</p>
        </div>
        <div
          className={`w-100 d-flex flex-column align-items-center justify-content-evenly text-center ${styles.userDetail}`}
          style={{ borderTop: "1px solid rgb(230, 230, 240)" }}
        >
          <label>{emailLabel}</label>
          <p style={{ lineBreak: "anywhere", padding: "2px" }}>
            {" "}
            {id === 1 ? email : codeMeli}
          </p>
        </div>
        <div
          className={`w-100 d-flex flex-column align-items-center justify-content-evenly text-center ${styles.userDetail}`}
          style={{ borderTop: "1px solid rgb(230, 230, 240)" }}
        >
          <label>{postal}</label>
          <p className={`${styles.twoLine}`}>
            {" "}
            {id === 1 ? postalCode : address}
          </p>
        </div>
      </div>
    </>
  );
}

export default UserProfile;
